/**
 * DevExtreme (esm/ui/form/components/empty_item.js)
 * Version: 21.1.6
 * Build date: Mon Sep 27 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var FIELD_EMPTY_ITEM_CLASS = "dx-field-empty-item";
export function renderEmptyItemTo(_ref) {
    var {
        $container: $container
    } = _ref;
    return $container.addClass(FIELD_EMPTY_ITEM_CLASS).html("&nbsp;")
}
